//import roles from "@/roles";
import layouts from "../../layout";
import AuthorizerSwitcher from "@/views/modules/authorizer/switcher/switcher.vue";

export default {
  path: "/authorizer",
  name: "authorizer",
  component: () =>
    import(
      /* webpackChunkName: "Authorizer" */ "@/views/modules/authorizer/authorizer.vue"
    ),
  redirect: {
    name: "authorizer-switcher"
  },
  meta: {
    auth: true,
    //title: "Authorizer",
    //tags: ["authorizer"],
    title_i18n: "Autorizador"
  },
  children: [
    {
      path: "switcher",
      name: "authorizer-switcher",
      component: AuthorizerSwitcher,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "switcher",
        title_i18n: "Inactivador",
        tags: ["authorizer", "switcher"],
        index: true
      }
    }
  ]
};
